import { withNaming } from '@bem-react/classname';

export const bemCN = withNaming({ e: '__', m: '_' });
